export class ModuleHolder {
  module: any;
  exports: any;
  moduleName: string;
}
